export default [
  { name: 'name', label: 'Client Name', component: 'input' },
  { name: 'rateLimit', label: 'Rate Limit (/minute)', component: 'input', type: 'number' },
  {
    name: 'allowedStudentFilters',
    label: 'Student Filters',
    component: 'select',
    mode: 'multiple',
    options: [
      { id: 'instrideProfileId', label: 'Instride Profile Id' },
      { id: 'instrideProgramId', label: 'Instride Program Id' }
    ]
  },
  { name: 'isActive', label: 'Is Active', component: 'checkbox' }
];
